import { fmtRepeat } from "@/lib/time";

export const PRIORITIES = [
  { key: "high", label: "High", every: "Every 15 min", minutes: 15, color: "#ef4444" },
  { key: "medium", label: "Medium", every: "Every hour", minutes: 60, color: "#f59e0b" },
  { key: "low", label: "Low", every: "Every 4 hours", minutes: 240, color: "#3b82f6" },
];

const CUSTOM = { key: "custom", label: "Custom", color: "#a1a1aa" };

export const priorityOf = (key) => PRIORITIES.find((p) => p.key === key) || CUSTOM;

export function scheduleText(r) {
  const p = priorityOf(r.priority);
  if (p.key !== "custom") return `${p.label} · ${p.every.toLowerCase()}`;
  return r.repeat_minutes ? `Custom · ${fmtRepeat(r.repeat_minutes)}` : "One-off";
}


// Minutes a reminder has been nagging past its due time; 0 if it isn't overdue (future, done, or a scheduled repeat).
export const overdueMinutes = (r) => {
  if (r.status === "done" || (r.priority === "custom" && r.repeat_minutes)) return 0;
  const since = r.first_sent_at || (r.last_sent_at && r.due_at);
  if (!since || !r.due_at || new Date(r.due_at) > Date.now()) return 0;
  return Math.max(0, (Date.now() - new Date(since)) / 60000);
};
